import { render, staticRenderFns } from "./CustomerSecondaryData.vue?vue&type=template&id=63097a20&scoped=true&"
import script from "./CustomerSecondaryData.vue?vue&type=script&lang=js&"
export * from "./CustomerSecondaryData.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSecondaryData.vue?vue&type=style&index=0&id=63097a20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63097a20",
  null
  
)

export default component.exports